import { render, staticRenderFns } from "./fittech_list.vue?vue&type=template&id=4dbdba95"
import script from "./fittech_list.vue?vue&type=script&lang=js"
export * from "./fittech_list.vue?vue&type=script&lang=js"
import style0 from "./fittech_list.vue?vue&type=style&index=0&id=4dbdba95&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports